import styled from 'styled-components';
import { ArrayTogglerBehaviorTypes } from 'verticals/hotels-dweb/src/shared/hooks/useArrayToggler';

const InfoWrap = styled.section(
  props => `
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;

    @media only screen and (min-width:320px) and (max-width: 767px){
        width:100%;
        margin-top: 1.5rem;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
        width:100%;
        margin-top: 1.5rem;
    }
  `,
);

export const InfoStripWrapper = styled(InfoWrap)(
  props => `
    width: 100%;
    box-shadow: 0 2px 6px 0 rgba(149, 149, 149, 0.5);
    border: solid 1px #99caf3;
    background-color: #eff7ff;
    overflow: hidden;
  `,
);

export const InfoBlockWrapper = styled(InfoWrap)(
  props => `
    width:50%;
    flex-direction: column;
  `,
);

export const InfoBlockInner = styled.div(
  props => `
    width:100%;
    display: flex;
    padding:0 ${props.theme.spacing.large.l45} 0 ${props.theme.spacing.large.l60};

    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: 0;
      overflow: auto;
      ::-webkit-scrollbar {
        display: none;
      }
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      padding: 0;
      overflow: auto;
      ::-webkit-scrollbar {
        display: none;
      }
    }
    @media only screen and (min-width:1025px) and (max-width: 1300px){
      width: 98%;
      margin: 0 auto;
      padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing};
    }
  `,
);

export const InfoHeadWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.nospacing};
    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
      align-items: center;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px){
      padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
    }
    @media only screen and (min-width: 1025px) and (max-width: 1300px){
      padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l20} ${props.theme.spacing.base};
    }
  `,
);

export const InfoHeadText = styled.h2(
  props => `
    color: ${props.theme.colors.blue.dark};
    font-size: ${props.theme.font.large.font20};
    line-height: ${props.theme.font.lineHeight.base};
    font-weight:${props.theme.font.fontWeight.black};

    @media only screen and (min-width:320px) and (max-width: 991px){
      font-size: ${props.theme.font.large.font17};
      text-align: center;
    }

    @media only screen and (min-width:992px) and (max-width: 1024px){
      font-size: ${props.theme.font.large.font22};
      text-align:center;
    }
    @media only screen and (min-width: 1025px) and (max-width: 1300px){
      font-size: ${props.theme.font.large.font25};
    }
  `,
);

export const MoreInfoList = styled.ul(
  props => `
    width:100%;
    display: flex;

    li{
      display: flex;
      padding: 1rem;
      width: 25%;
    }

    @media only screen and (min-width:320px) and (max-width: 767px){
      width:150rem;
      flex-direction: row;
      padding: 1rem 0;
      align-items: center;
      justify-content: center;

      li{
        width:30rem;
        margin-right: ${props.theme.spacing.base};
        padding: 1rem 0;
      }
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      width:150rem;
      flex-direction: row;
      padding: 1rem 0;
      align-items: center;
      justify-content: center;

      li{
        width:30rem;
        margin-right: ${props.theme.spacing.base};
        padding: 1rem 0;
      }
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
      width:100%;
      flex-direction: row;

      li{
        width:100%;
        margin-right: ${props.theme.spacing.base};
        padding: ${props.theme.spacing.large.base} ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
        display: flex;
        align-items: center;
        flex-direction: row;
      }
    }
    `,
);

export const IconWrapper = styled.div(
  props => `
    width: 5rem;
    height: 5rem;
    display: flex;

    @media only screen and (min-width:320px) and (max-width: 767px){
      border: none;
      height: auto;
      width: 6rem;
      padding-left: 1.5rem;
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      border: none;
      height: auto;
      width: 6rem;
      padding-left: 1.5rem;
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
      width: 6rem;
      height: 6rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
);

export const InfoOuterWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 1.5rem;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    align-items: flex-start;
  }

  @media only screen and (min-width: 1025px) and (max-width: 1300px) {
    width: 85%;
    padding-left: 0.5rem;
  }
`;

export const MoreInfoHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.dark};
    font-weight: ${props.theme.font.fontWeight.black};
    line-height: ${props.theme.font.lineHeight.small};

    @media only screen and (min-width:768px) and (max-width: 1024px){
      font-size: ${props.theme.font.large.font14};
      text-aling:center
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
      padding-top: 0;
      font-size: ${props.theme.font.large.font13};
    }
  `,
);

export const MoreInfoSubText = styled.span(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    opacity: 0.8;
    padding-top: ${props.theme.spacing.small.s5};
    line-height: ${props.theme.font.lineHeight.small};

    @media only screen and (min-width:768px) and (max-width: 1024px){
      font-size: ${props.theme.font.small.font11};
      text-aling:${props.theme.font.textAlign.center};
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
      font-size: ${props.theme.font.large.font11};
    }
  `,
);

export const HomeBannerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    position: absolute;
    bottom: 0;
    left: -1rem;

    @media only screen and (min-width:320px) and (max-width: 767px){
        display: flex;

        img{
          width:100%;
          height: 7rem;
        }
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
        display: none;
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
        left: 0;
    }
  `
);

export const BannerCountInnerLeft = styled.div`
  position: absolute;
  left: 3rem;
  top: 7.5rem;
  width: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const BannerCountInnerRight = styled.div`
  position: absolute;
  left: 35rem;
  top: 4rem;
  width: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const BannerCountHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font28};
    color: ${props.theme.colors.black};
    font-weight: ${props.theme.font.fontWeight.black};
  `,
);

export const BannerCountSubText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color:${props.theme.colors.black};
  `,
);

export const ArrowIconRightWrapper = styled.div(
  props => `
    margin: auto 0;
    cursor: pointer;
    position: absolute;
    right: 0rem ;
    top:0;
    height:9rem;
    width:24rem;
    background-image: linear-gradient(to right, rgba(239, 247, 255, 0) 1%, #eff7ff 56%);
    align-items: center;
    justify-content: center;
    display: flex;
    @media only screen and (min-width:320px) and (max-width: 767px){
      display: none;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      display: none;
    }
  `
);


export const ArrowIconLeftWrapper = styled.div(
  props => `
    margin: auto 0;
    cursor: pointer;
    position: absolute;
    left: 0rem ;
    top:0;
    height:9rem;
    width:25rem;
    background-image: linear-gradient(to right, #eff7ff  5%,  rgba(239, 247, 255, 0.4) 56%);
    align-items: center;
    justify-content: center;
    display: flex;
    @media only screen and (min-width:320px) and (max-width: 767px){
      display: none;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      display: none;
    }
  `
);


export const VideoWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    justify-content: center;
    height: 32rem;
    margin: 0;
    z-index:1;
    position: relative;

    @media only screen and (min-width:320px) and (max-width: 767px){
      height: 23rem;
      margin: 0;
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      height: 32rem;
    }

    @media only screen and (min-width:1025px) and (max-width: 1300px){
      height: 32rem;
    }
  `
);

export const VideoSelectWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right: 0;
    z-index: 1;
    background-color: rgba(0,0,0,0.5);
    flex-direction: column;
    border-radius: 1.6rem;
  `
);

export const SelectHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font20};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};
  `
);

export const SelectOptionList = styled.ul(
  props => `
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: ${props.theme.spacing.large.l20};

    li{
      display: flex;
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
      background-color: ${props.theme.colors.grey.lighte7};
      border-radius: 0.4rem;
      margin-right: ${props.theme.spacing.base};
      margin-bottom: ${props.theme.spacing.base};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.black.base};
      cursor: pointer;
    }
  `
)

export const VideoText = styled.div(
  props => `
    position: absolute;
    padding: ${props.theme.spacing.base};
    color: ${props.theme.colors.white.base};
    font-size: ${props.theme.font.large.font18};
    left:0rem;
    top:0;
  `
);

export const VideoInnerWrap = styled.div(
  props => `
    width: 57rem;
    position:relative;
    border-radius: 16px;
    display: flex;
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:38rem;
    }
  `
)

export const VideoBlock = styled.img(
  props => `
    width: 100%;
    height: 100%;
    object-fit: cover;
  `
);

export const PlayIconWrapper = styled.div(
  props => `
    width: 5.5rem;
    height: 4rem;
    position: absolute;
    top: 50%;
    left: 50%;
    background: rgba(59, 55, 56, 0.9);
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    padding: 12px 24px;
    cursor: pointer;
  `
);

export const PlayIcon = styled.div(
  props => `
    width: 0;
    height: 0;
    border-top: 1rem solid transparent;
    border-bottom: 1rem solid transparent;
    border-left: 1.4rem solid white;
    margin: 0 auto;
  `
);

export const BannerImgWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5rem;
    z-index: 1;
  `
);

export const BannerImg = styled.div(
  props => `
    width:58rem;
    height: 7rem;
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:100%;
    }
    display: flex
    justify-content: center
    align-items: center
  `
);

export const BannerImgAltText = styled.div(
    props => `
      width:30rem
      height: 7rem
      margin: 0 auto
      background-color:#FFDF80
      text-align: center
      padding : .5rem
      display: flex
      justify-content: center
      align-items: center
      font-size : 25px
      font-weight:8000
      border-radius : 15px
      font-weight: bold
      color: #38496b

      @media only screen and (min-width:320px) and (max-width: 767px){
        width:90%;
        font-size : 18px
      }

    `
  );


export const FlightBannerImgWrap = styled.div(
  props => `
    width: 100%;
    height: 14rem;
    margin: ${props.theme.spacing.large.l15} 0;
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:100%;
      margin: ${props.theme.spacing.large.l15} 0 0;
    }
    display: flex;
    align-items: center;
    justify-content: center;
  `
);

export const FlightBannerInnerWrap = styled.div(
  props => `
    width:100%;
    max-width: 575px;
    height: 137px;
    padding: 5px 0 0 20px;
    object-fit: contain;
    border-radius: 6px;
    background-image: linear-gradient(to right, #ffd2d9 0%, rgba(255, 255, 255, 0) 234%);
    position: relative;
    z-index: 1;
    overflow: hidden;
  `
);

export const FlightBannerImgInner = styled.div(
  props => `
    position: absolute;
    bottom: -3px;
    right: -4.5rem;
    display: flex;
  `
);

export const FlightIntroTextWrap = styled.div(
  props => `
    width:80%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.large.l20};
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:100%;
    }
  `
);

export const IntroTextHeadFight = styled.p(
  props => `
    font-size: ${props.theme.font.large.font24};
    color: ${props.theme.colors.black.base};
    font-weight:${props.theme.font.fontWeight.black};
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font20};
    }
  `
);

export const IntoTextSubFlight = styled.p(
  props =>  `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};
  `
)
